import React from 'react'
import { Box } from '@sqymagma/elements'

const ContentLeft = ({children}) => {
    return (
        <Box width={[1, 1, 1/2]} pr={[0, 0, "36px"]} mb="m">
            {children}
        </Box>
    )
}

export default ContentLeft;